import { render } from "./EditorsPage.vue?vue&type=template&id=ef2d6730&ts=true"
import script from "./EditorsPage.vue?vue&type=script&lang=ts"
export * from "./EditorsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__